import { createFileRoute } from "@tanstack/react-router";
import { ReportsLibrary, reportsHead } from "@/components/ReportsLibrary";

export const Route = createFileRoute("/reports")({
  head: () => reportsHead("en"),
  component: () => <ReportsLibrary lang="en" />,
});
